module.exports = __webpack_public_path__ + "img/threats-tab.2b09be25.png";